import { render, staticRenderFns } from "./common-back.vue?vue&type=template&id=48027f9d&"
import script from "./common-back.vue?vue&type=script&lang=ts&"
export * from "./common-back.vue?vue&type=script&lang=ts&"
import style0 from "./common-back.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports